import renderInputField from 'components/FormControls/textInput'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Field } from 'redux-form'
import TaxNumberField from 'modules/Forms/Finance/PaymentProfileCreate/subcomponents/TaxNumberField'
import JuridicalForeign from './Foreign'
import JuridicalRu from './Ru'

const JuridicalFormFields = ({ details, form, disabled = false }) => {
  const { t } = useTranslation()

  return (
    <>
      <div className={'margin-bottom-16'}>
        <TaxNumberField
          disabled={disabled}
          form={form}
          suggestAvailable={details?.country_code && details?.country_code === 'ru'}
          label={t('payment_profiles::new.fields.details.tax_number.label', {
            context: details?.country_code && details?.country_code !== 'ru' ? 'not_ru' : '',
          })}
        />
      </div>

      <div className={'margin-bottom-16'}>
        <Field
          disabled={disabled}
          fullWidth
          name="details.organisation_name"
          component={renderInputField}
          label={t('payment_profiles::new.fields.details.organisation_name.label')}
          t={t}
          normalize={(value) => value.replace(/[«|»]/g, '"')}
        />
      </div>

      {details?.country_code &&
        (details.country_code === 'ru' ? (
          <JuridicalRu
            details={details}
            form={form}
          />
        ) : (
          <JuridicalForeign details={details} />
        ))}
    </>
  )
}

JuridicalFormFields.propTypes = {
  details: PropTypes.object,
  form: PropTypes.string,
  disabled: PropTypes.bool,
}

export default JuridicalFormFields
